import iro from '@jaames/iro';
import { IroColorPicker } from '@jaames/iro/dist/ColorPicker';
import classNames from 'classnames';
import { forwardRef, useEffect, useRef } from 'react';
import { mergeRefs } from '@/shared/lib/utils/merge-refs';

type Props = React.HTMLAttributes<HTMLElement> & {
    onColorChange?: (color: string) => void;
    color: string;
};

const ColorPicker = forwardRef<HTMLDivElement, Props>(({ onColorChange, color, ...props }, ref) => {
    const el = useRef<HTMLDivElement>(null);
    const instance = useRef<IroColorPicker | null>(null);

    const getPickerSize = () => {
        const width = window.innerWidth;
        if (width < 1200) return 256;
        if (width < 1700) return 300;
        return 366;
    };

    useEffect(() => {
        if (instance.current) {
            instance.current.color.hexString = color;
        }
    }, [color]);

    useEffect(() => {
        if (el.current && !instance.current) {
            instance.current = iro.ColorPicker(el.current, {
                width: getPickerSize(),
                display: 'flex',
                layoutDirection: 'horizontal',
                color: color,
                handleRadius: 10,
                borderWidth: 1,
                borderColor: '#fff',
            });
            instance.current.on(['color:init', 'color:change'], (color: any) => {
                onColorChange?.(color.hexString);
            });
        }
    }, [onColorChange]);

    return <div {...props} ref={mergeRefs([ref, el])} className={classNames('color-picker', props.className)} />;
});

ColorPicker.displayName = 'ColorPicker';

export default ColorPicker;
